import React from 'react'
import { css } from '@emotion/react'

import { runOnNextTick, propFunc } from 'util/functions'

import SpacedItems from 'shared/components/ui/SpacedItems'

const truncateStyle = css`
  overflow: hidden;
  white-space: nowrap;
`

const subjectStyle = theme => css`
  color: ${theme.color.monochrome.superDark};
  font-family: ${theme.pageFont};
  font-weight: ${theme.fontWeight.medium};
`

const largerSubjectStyle = theme => css`
  font-size: ${theme.fontSize.x4large};

  @media print {
    overflow: visible;
    white-space: normal;
  }
`
const smallerSubjectStyle = theme => css`
  font-size: ${theme.fontSize.x2large};
`
const printableTicketNumberStyle = theme => css`
  font-size: ${theme.fontSize.x2large};
`

export default class EditableSubjectNormalState extends React.Component {
  state = {}

  componentDidMount() {
    this.checkOverflow()
    window.addEventListener('resize', this.runCheckOverflow)
  }

  componentDidUpdate(prevProps) {
    if (this.props.ticket.title !== prevProps.ticket.title) {
      // pnagy: here we explicitly want to make sure that we'll
      // remasure the size of the subject text.
      // eslint-disable-next-line react/no-did-update-set-state
      this.setNotOverflown()
      this.checkOverflow()
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.runCheckOverflow)
  }
  // pnagy: In this component we have an editable subject.
  // This method checks whether the subject is overflowing and
  // needs to be truncated. When it does we'll decrease the font
  // size and let it break into multiple lines. To do this we need
  // to store if the content fits its box or not

  setNotOverflown = () => {
    this.setState({ hasOverflow: false })
  }

  runCheckOverflow = () => {
    if (this.timeout) clearTimeout(this.timeout)
    this.timeout = runOnNextTick(this.checkOverflow)
  }

  checkOverflow = () => {
    if (!this.title) return
    const isOverflown = this.title.scrollWidth !== this.title.offsetWidth
    if (isOverflown && this.state.hasOverflow !== isOverflown) {
      this.setState({ hasOverflow: isOverflown })
    }
  }

  takeRef = node => {
    this.title = node && node.firstChild
    this.checkOverflow()
  }

  render() {
    const { ticket, doStartEditingTicketTitle } = this.props
    const { hasOverflow } = this.state
    return (
      <SpacedItems.Container
        verticalAlign="center"
        horizontalAlign="center"
        gap="mini"
      >
        <SpacedItems.Item
          className="fullstack-ticket-title"
          grow={1}
          css={css`
            min-width: 0;
          `}
        >
          {!hasOverflow && (
            <div ref={this.takeRef}>
              <div
                css={[truncateStyle, subjectStyle, largerSubjectStyle]}
                onClick={propFunc(
                  doStartEditingTicketTitle,
                  ticket.id,
                  ticket.title
                )}
              >
                {ticket.title || 'Add Subject'}
              </div>
            </div>
          )}
          {hasOverflow && (
            <div
              css={[subjectStyle, smallerSubjectStyle]}
              onClick={propFunc(
                doStartEditingTicketTitle,
                ticket.id,
                ticket.title
              )}
            >
              {ticket.title || 'Add Subject'}
            </div>
          )}
        </SpacedItems.Item>
        <SpacedItems.Item className="visible-only-in-print">
          <div css={printableTicketNumberStyle}>#{ticket.id}</div>
        </SpacedItems.Item>
      </SpacedItems.Container>
    )
  }
}
